// The <QueryBoundary/> adapter half of `lib/paged.ts` — split out to keep both
// files under the dashboard's 150-LOC cap, and because it has its own reason to
// change: it exists only to bridge a paged list to the boundary's contract.
//
// The rule it encodes is the one every hand-rolled copy had to restate: report
// loading/error ONLY while nothing is on screen. Otherwise a "Load more" that is
// slow (or that fails) blanks the rows the reader is already looking at and
// replaces them with a skeleton or an error panel.

import type { PagedView, PageQuery } from './paged-types';

export function pagedView<T>(query: PageQuery<T>, rows: () => readonly T[]): PagedView<T> {
  return {
    get isLoading() {
      return query.isLoading && rows().length === 0;
    },
    get isError() {
      return query.isError && rows().length === 0;
    },
    get error() {
      return query.error;
    },
    get data(): readonly T[] | undefined {
      return rows();
    },
    refetch: () => query.refetch(),
  };
}
